import { Field } from 'formik';
import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { config } from '../../../utils/config';
import OptionsField from '../../formik/OptionsField';
import Guest from './Guest';
import Register from './Register';
import SignIn from './SignIn';
import './style.scss';

const additionalConfig: Record<string, { hasIcon?: boolean; form?: FunctionComponent }> = {
  signIn: { form: SignIn },
  register: { form: Register },
  guest: { form: Guest },
};

const authMethods = [{ key: 'signIn' }, { key: 'register' }, { key: 'guest' }];

type AuthStepOptionsProps = {
  isEmbeddedAuth?: boolean;
};

const AuthStepOptions = ({ isEmbeddedAuth }: AuthStepOptionsProps) => {
  const { formatMessage } = useIntl();
  const options = authMethods
    .filter(auth => (!config.features.guestCheckout.enabled || isEmbeddedAuth ? auth.key !== 'guest' : true))
    .map(({ key }) => ({
      key,
      label: formatMessage({ id: `auth.options.${key}.label` }),
      form: additionalConfig[key]?.form,
    }));

  return (
    <div className="auth-step-options">
      <Field name="type" component={OptionsField} options={options} isVertical dataTestIdPrefix="authOptions" />
    </div>
  );
};

export default AuthStepOptions;
